import React from 'react';
import PropTypes from 'prop-types';
import Countdown from 'react-countdown-now';

//  ----------------------------------------------------------------------------------------------//
function SixtySeconds(props) {
  const renderer = ({ total }) => (
    <span className={props.className || 'sixty-seconds'}>
      <span className="notranslate">
        {' ' + Math.floor(total / 1000) + ' '}
      </span>
      <span>seconds</span>
    </span>
  );

  return (
    <Countdown
      date={Date.now() + (props.ticks || 0) * 1000}
      renderer={renderer}
      onComplete={props.onFinish}
    />
  );
}

SixtySeconds.propTypes = {
  ticks: PropTypes.number,
  className: PropTypes.string,
  onFinish: PropTypes.func
};

SixtySeconds.defaultProps = {
  ticks: 60
};

export default SixtySeconds;
